<template>
  <b-form-select
    v-model="local_value"
    :options="options"
    v-bind="$props"
  ></b-form-select>
</template>

<script>
import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";
import { mapActions } from "vuex";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: null,
  })
);

export default {
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    options: [],
  }),
  computed: {
    local_value: {
      set(value) {
        this.$emit("input", value);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    ...mapActions("files", ["ActionGetFilesCategoriasToSelect"]),
  },
  async created() {
    this.options = await this.ActionGetFilesCategoriasToSelect();
  },
};
</script>
